import React from 'react';
import { Controller } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Input } from '../../../shared';
import {
    emailKey,
    emailLabelText,
    enterEmailText,
    enterPasswordText,
    passwordKey,
    passwordLabelText
} from '../../../shared/consts';
import { forgotPasswordText } from '../textConsts';
import styles from '../../Main.module.scss';
import PropTypes from 'prop-types';

export const LoginFormFields = ({ control, register, errors, inviteForm }) => (
    <>
        <Controller
            name={emailKey}
            control={control}
            render={({ field: { onChange, value } }) => (
                <Input
                    type="text"
                    id="email"
                    label={emailLabelText}
                    errors={errors[emailKey]}
                    placeholder={enterEmailText}
                    value={value}
                    onChange={(e) => {
                        onChange(e.target.value.trim());
                    }}
                    register={register(emailKey).ref}
                />
            )}
        />

        {!inviteForm && (
            <Controller
                name={passwordKey}
                control={control}
                render={({ field: { onChange, value } }) => (
                    <Input
                        type="password"
                        id="password"
                        label={passwordLabelText}
                        errors={errors[passwordKey]}
                        placeholder={enterPasswordText}
                        value={value}
                        onChange={onChange}
                        secondLabel={() => (
                            <div className={styles.forgot_password}>
                                <Link tabIndex="-1" to="/request_password_reset">
                                    {forgotPasswordText}
                                </Link>
                            </div>
                        )}
                        register={register(passwordKey).ref}
                    />
                )}
            />
        )}
    </>
);

LoginFormFields.propTypes = {
    control: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    inviteForm: PropTypes.bool
};
